import React, { type ButtonHTMLAttributes } from 'react';
import Button from './Button';

interface EditButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    size?: 'sm' | 'md' | 'lg';
    className?: string;
    disabled?: boolean;
    showText?: boolean;
    isLoading?: boolean;
    text?: string;
}

const EditButton: React.FC<EditButtonProps> = ({
    size = 'md',
    className = '',
    disabled = false,
    showText = false,
    isLoading = false,
    text = 'Edit',
    ...rest
}) => {
    return (
        <Button
            className={`flex items-center ${className}`}
            disabled={disabled}
            isLoading={isLoading}
            size={size}
            variant="outline-dark"
            {...rest}
        >
            <svg
                className={`w-4 h-4 ${showText ? 'mr-1' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M16.862 3.487a2 2 0 012.828 2.828L8.5 17.505 4 19l1.495-4.5L16.862 3.487z"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <path d="M15 5l4 4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
            </svg>
            {showText && text}
        </Button>
    );
};

export default EditButton;
